import { render, staticRenderFns } from "./RecommendProduct.vue?vue&type=template&id=3d318826&"
import script from "./RecommendProduct.vue?vue&type=script&lang=ts&"
export * from "./RecommendProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports